export default __webpack_public_path__ + "images/6ed4ac608e49f54b42e3226937a43bce-mobile.webp";